import React from "react";
var __jsx = React.createElement;
export default function Anchor() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "11",
    height: "11",
    viewBox: "0 0 11 11",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.92071 3.61696C2.69872 3.3933 2.33887 3.3933 2.11688 3.61696C1.89489 3.84063 1.89489 4.20326 2.11688 4.42692L5.14845 7.48144C5.36849 7.7032 5.72459 7.70541 5.94734 7.4864L8.97892 4.50623C9.20362 4.28534 9.20806 3.92274 8.98882 3.69634C8.76959 3.46993 8.40971 3.46547 8.18501 3.68636L5.5553 6.27148L2.92071 3.61696Z",
    fill: "white",
    "fill-opacity": "0.8"
  }));
}
Anchor.displayName = "Anchor";